import React from 'react'

import { Box, FontFamily, FontWeight, withCitrusTheme } from '@gousto-internal/citrus-react'

const ClampedTitle = withCitrusTheme(Box, (theme) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontFamily: theme.tokens.FontFamilies[FontFamily.Book],
  fontWeight: FontWeight.SemiBold,
  fontSize: theme.tokens.fontSizes[3].fontSize,
  lineHeight: theme.tokens.fontSizes[3].lineHeight,
}))

type RecipeTitleProps = {
  title: string
}

export const RecipeTitle = ({ title }: RecipeTitleProps) => (
  <Box maxWidth="80%">
    <ClampedTitle>{title}</ClampedTitle>
  </Box>
)
